import { trackOpenAiLead } from "./openaiPixel";
import { posthog } from "./posthogClient";

export type ConversionEvent =
  | { event: "cta_click_hero"; cta_label?: string }
  | {
      event: "cta_click_specialist";
      // "cta_band": faixa de CTA no meio/fim de uma LP (não é o rodapé).
      // "free_trial": card de teste grátis (ex.: /integracoes).
      // "blog_post": botão do bloco `cta-lead` dentro do texto do post.
      // "tool_result": convite logo abaixo do resultado de uma ferramenta (/ferramentas/*).
      // "whatsapp_blocked": faixa laranja "WhatsApp bloqueado" da home.
      location?:
        | "header"
        | "whatsapp_blocked"
        | "hero"
        | "success_case"
        | "cta_band"
        | "free_trial"
        | "blog_post"
        | "tool_result";
      // Só no blog: qual dos dois botões do post foi clicado.
      cta_label?: "cta_lead" | "blog_cta";
      post_slug?: string;
    }
  | {
      // Uso de uma ferramenta gratuita de /ferramentas. Só as ações que
      // mostram intenção — imprimir, compartilhar —, nunca cada tecla digitada.
      event: "tool_action";
      tool:
        | "gerador_carne"
        | "simulador_crediario"
        | "calculadora_inadimplencia";
      action: "print" | "whatsapp_share";
    }
  | {
      event: "cta_click_whatsapp";
      location?:
        | "float"
        | "hero"
        | "footer"
        | "header"
        | "success_case"
        | "cta_band"
        | "auth"
        | "blog_post"
        | "demo_welcome";
      post_slug?: string;
    }
  | {
      event: "form_submit_demo";
      stores_range?: string;
    }
  | {
      // Etapa do form de demo concluída. Mede onde o visitante desiste entre
      // abrir o modal e enviar (form_submit_demo).
      event: "form_step_demo";
      step: "contact";
    }
  | {
      // Indicação enviada por uma LP de parceria (ex.: /alpha7). Separado do
      // form_submit_demo porque quem preenche é o vendedor do parceiro, não o
      // lojista — funil e relatório são outros.
      event: "form_submit_partner";
      partner: "alpha7";
      stores_count?: number;
    }
  | { event: "scroll_depth_75"; page_path?: string }
  | { event: "view_pricing"; section?: string }
  | { event: "press_article_click"; outlet: string }
  | { event: "press_highlight_click"; outlet: string }
  | { event: "login_success"; method?: "password" | "otp" }
  | {
      event: "fake_door_click";
      test_key: string;
      variant: string;
      button_label: string;
    };

export type WhatsappCtaLocation = Extract<
  ConversionEvent,
  { event: "cta_click_whatsapp" }
>["location"];

type DataLayerWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>;
};

export const trackEvent = (payload: ConversionEvent): void => {
  if (typeof window === "undefined") return;

  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push({ ...payload });

  // Espelha o evento de conversão no PostHog.
  const { event, ...properties } = payload;
  posthog.capture(event, properties);

  if (event === "form_submit_demo") trackOpenAiLead();
};
